import { useTheme } from '@rneui/themed'
import { useRoutingContext } from 'app/routing_context'
import { AddShiftProps, EditShiftProps } from 'home/stack/types'
import { t } from 'app/i18l'
import React, { useCallback, useLayoutEffect } from 'react'
import { showHeaderTitle } from 'shared/header/header_title'
import { useShift } from 'shifts/queries/detail'
import { EditShiftView } from 'shifts/screens/edit_shift/view'
import { useShiftActions } from 'shifts/shift_actions_context'
import { useRecentStoresContext } from 'stores/context'
import { useStore } from 'stores/queries/details'

export function EditShiftScreen({ navigation, route }: EditShiftProps) {
  const { handleNavigation } = useRoutingContext()
  const shiftQuery = useShift(route.params)
  const { theme } = useTheme()
  const { loading, onEditShift, onCreateShift, setShiftParams, shiftParams } =
    useShiftActions()
  const isAddAndAssign = !!route.params?.addAndAssign

  useLayoutEffect(() => {
    showHeaderTitle(
      navigation,
      shiftQuery.data ? t('editShift') : t('addShift')
    )
  }, [navigation, shiftQuery.data, theme])

  const { activeStoreId } = useRecentStoresContext()
  const storeQuery = useStore(activeStoreId)

  const onSelectCrew = useCallback(() => {
    handleNavigation({
      routeName: 'user_list',
      routeParams: {
        type: 'store',
        addAndAssign: true,
        filter: 'cover_eligible',
        shift_date: shiftParams?.date,
        start_time: shiftParams?.startTime,
        end_time: shiftParams?.endTime,
        position: shiftParams?.position?.name,
      },
    })
  }, [
    handleNavigation,
    shiftParams?.date,
    shiftParams?.endTime,
    shiftParams?.position,
    shiftParams?.startTime,
  ])

  return (
    <EditShiftView
      store={storeQuery.data}
      shift={shiftQuery.data?.shift}
      onSave={shiftQuery.data?.shift ? onEditShift : onCreateShift}
      onSelectCrew={onSelectCrew}
      isAddAndAssign={isAddAndAssign}
      onShiftParamsChanged={setShiftParams}
      loading={loading}
    />
  )
}

export function AddShiftScreen(props: AddShiftProps) {
  return EditShiftScreen(props as unknown as EditShiftProps)
}
